import { render, staticRenderFns } from "./ghacBanner.vue?vue&type=template&id=6ce6ccf4&"
import script from "./ghacBanner.vue?vue&type=script&lang=js&"
export * from "./ghacBanner.vue?vue&type=script&lang=js&"
import style0 from "./ghacBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports